import { Box, Stack } from '@src/components';

import useAbsencesTimeline from '../../../hooks';
import DaysListSwitcher from './DaysListSwitcher';
import MonthListSwitcher from './MonthListSwitcher';
import MonthSwitcher from './MonthSwitcher';
import YearSwitcher from './YearSwitcher';

export default function Header({currentDates}) {
  const { calendar, isMonthView, isMonthOrHalfMonthView } = useAbsencesTimeline();

  const toMonthView = (year, monthIndex) => {
    if (!year) {
      year = currentDates.start.getFullYear(); 
    }
    if (!monthIndex) {
      monthIndex = currentDates.start.getMonth();
    }

    calendar.setMonthView(year, monthIndex); 
  };

  const switchYear = (delta) => {
    const year = currentDates.start.getFullYear(); 
    const month = currentDates.start.getMonth();
    const day = currentDates.start.getDay();
    if (!isMonthView) {
      toMonthView();
    }
    calendar.gotoDate(new Date(year + delta, month, day));
  };
  const handlePrevYear = () => switchYear(-1);
  const handleNextYear = () => switchYear(1);

  const handlePrev = () => { 
    if (!isMonthView) {
      toMonthView();
    }
    else {
      calendar.prev();
    }
  };
  const handleNext = () => {
    if (!isMonthView) {
      toMonthView();
    }
    calendar.next();
  };

  const handleGotoMonth = (year, monthIndex) => {
    if (!isMonthView) {
      toMonthView(year, monthIndex); 
    }
    calendar.gotoDate(new Date(year, monthIndex, 1));
  };

  const handleGotoHalfMonth = (year, monthIndex) => {
    calendar.setHalfMonthView(year, monthIndex);
  };


  return (
    <Stack direction="row" >
      <Box sx={StyleSheet.yearSwitch}>
        {isMonthOrHalfMonthView
          ? (
            <YearSwitcher
              currentDates={currentDates}
              onPrev={handlePrevYear}
              onNext={handleNextYear}
            />)
          : (
            <MonthSwitcher currentDates={currentDates} />
          )}

      </Box>

      <Box sx={StyleSheet.monthSwitch}>
        {isMonthOrHalfMonthView ?
          (
            <MonthListSwitcher
              currentDates={currentDates}
              onNext={handleNext}
              onPrev={handlePrev}
              onGotoMonth={handleGotoMonth}
              onGotoHalfMonth={handleGotoHalfMonth}
            />
          )
          : <DaysListSwitcher currentDates={currentDates} />}
      </Box>
    </Stack>
  );

}

const StyleSheet = {
  yearSwitch: {
    width: '350px',
  },
  monthSwitch: {
    flexGrow: 1,
  },
};
